import styles from './Checkbox.module.scss';
import { CheckedIcon, MinusIcon } from './components';

export interface CheckboxProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  checked: boolean;
  testId: string;
  type?: 'checked' | 'indeterminate';
  disabled?: boolean;
  error?: boolean;
}

export const Checkbox = ({
  type = 'checked',
  testId,
  ...props
}: CheckboxProps) => {
  return (
    <span
      {...props}
      className={styles.checkbox}
      data-test-id={`${testId}-container`}
      data-checked={props.checked}
      data-disabled={props.disabled}
      data-error={props.error}
    >
      {props.checked &&
        (type === 'checked' ? (
          <CheckedIcon data-test-id={`${testId}-checked-icon`} />
        ) : (
          <MinusIcon data-test-id={`${testId}-minus-icon`} />
        ))}
    </span>
  );
};
